const MITRA_LAKUPANDAI_URL = `${process.env.API_V4_HOST}/_exclusive/mitra-lakupandai/digital-send`;

export const updateDigitalSendTransaction = ($axios, { transactionId, userAction }) =>
  $axios.$post(`${MITRA_LAKUPANDAI_URL}/${transactionId}/update`, { user_action: userAction });
